
<div class="modal-dialog" style="max-width: 600px;">
  <div class="modal-content">
    <form #dartForm="ngForm" (ngSubmit)="send()">
      <div class="modal-header">
        <h4>Request DART Correction</h4>
        <button class="close" type="button" (click)="close()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div class="row justify-content-center">
          <div class="col-md-11">
            <div class="alert alert-success" [hidden]="!sent">
              <button class="close" type="button" (click)="sent = false"><span aria-hidden="true">&times;</span></button>Sent!
            </div>
            <div class="form-group row">
              <label class="col-3 col-form-label">Deal ID:</label>
              <div class="col-9">
                <label class="col-form-label" [hidden]="!disableDealSelection">{{ disableDealSelection ? dealId : "" }}</label>
                <select class="form-control" [(ngModel)]="dealId" name="dealId" required [hidden]="disableDealSelection">
                  <option></option>
                  <option *ngFor="let deal of deals" value="{{deal.dartDealId + '.' + deal.dealVersion}}">{{deal.dartDealId}}</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label class="required" for="description"></label>Enter a message to send to the Account Lead(s).  All Transition Leads assigned to this project will receive a copy of this message.
              <textarea class="form-control" id="description" [(ngModel)]="description" name="description" rows="5" required></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="float-right">
          <div class="btn-group">
            <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
          </div>
          <div class="btn-group">
            <button class="btn btn-primary" type="submit">Send</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>